import { getFileNameUrl } from "configs/images.config";
import { memo } from "react";
import classes from "./ImageUploader.module.scss";

const ImageUploader = memo(
  ({ filename, selected, setSelectedImage, isCover }) => {
    return (
      <div
        className={`${classes["image"]} ${
          selected ? classes["selected"] : ""
        } ${isCover ? classes["cover"] : ""}`}
        onClick={setSelectedImage}
      >
        <img
          src={
            filename instanceof File
              ? URL.createObjectURL(filename)
              : getFileNameUrl(filename)
          }
          alt=""
        />
      </div>
    );
  }
);

export default ImageUploader;
